
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Shield, Users, Clock, AlertTriangle } from "lucide-react";
import { NotificationCenter } from "@/components/notifications/NotificationCenter";
import { SecurityAlerts } from "@/components/security/SecurityAlerts";

const SecurityAccessPage = () => {
  const accessLogs = [
    {
      id: 1,
      patron: "John Doe",
      venue: "Club Infinity",
      time: "10:30 PM",
      status: "Granted",
      method: "QR Scan"
    },
    {
      id: 2,
      patron: "Jane Smith",
      venue: "The Basement",
      time: "9:45 PM",
      status: "Denied",
      method: "Manual Check"
    },
    {
      id: 3,
      patron: "Mike Johnson",
      venue: "Club Infinity",
      time: "11:15 PM",
      status: "Granted",
      method: "QR Scan"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Shield className="h-6 w-6 text-purple-400" />
          <h1 className="text-2xl font-bold">Access Control</h1>
        </div>
        <NotificationCenter />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Users className="h-5 w-5 text-green-500" />
              <span className="text-sm font-medium">Active Patrons</span>
            </div>
            <p className="text-2xl font-bold">142</p>
            <p className="text-sm text-muted-foreground">Currently inside venues</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <Clock className="h-5 w-5 text-blue-500" />
              <span className="text-sm font-medium">Today's Entries</span>
            </div>
            <p className="text-2xl font-bold">298</p>
            <p className="text-sm text-muted-foreground">Total check-ins</p>
          </CardContent>
        </Card>

        <Card className="glass-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="h-5 w-5 text-red-500" />
              <span className="text-sm font-medium">Denied Entries</span>
            </div>
            <p className="text-2xl font-bold">7</p>
            <p className="text-sm text-muted-foreground">Access denied today</p>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <SecurityAlerts />
        
        <Card className="glass-card">
          <CardHeader>
            <CardTitle>Recent Access Logs</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {accessLogs.map((log) => (
                <div key={log.id} className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="flex items-center gap-4">
                    <div>
                      <p className="font-medium">{log.patron}</p>
                      <p className="text-sm text-muted-foreground">{log.venue} • {log.time}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant={log.status === "Granted" ? "default" : "destructive"}>
                      {log.status}
                    </Badge>
                    <span className="text-sm text-muted-foreground">{log.method}</span>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SecurityAccessPage;
